import { render, staticRenderFns } from "./VueIcon.vue?vue&type=template&id=cca4c910&"
import script from "./VueIcon.vue?vue&type=script&lang=js&"
export * from "./VueIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports